var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center",class:_vm.alto()},[_c('img',{staticClass:"imagen-404",attrs:{"src":require("@/assets/imagenes/404.jpg")}}),_c('h4',{staticClass:"text-muted"},[_vm._v("La página que solicitaste no existe")])])
}
var staticRenderFns = []

export { render, staticRenderFns }